<div class="page-content">
    <span class="content-header">
        <span class="title">Checkout</span>
    </span>
    <div class="content-body">
        <mat-card class="content-box">
            <mat-icon color="primary">card_giftcard</mat-icon>

            <div class="message-container">
                <h2>Thank you, your order is complete.</h2>
                <span class="message-body"> An email has been sent to </span>
                <span class="message-body" qa="gift-card-recipient">
                    {{ purchasedGiftCard?.recipientEmail }}
                </span>
                <div class="gift-card-info">
                    <div class="info">
                        <span class="label">Gift Card Amount:</span>
                        <span class="gift-card-amount" qa="gift-card-amount">{{
                            purchasedGiftCard?.giftCardAmount | dsiCurrency
                        }}</span>
                    </div>
                    <div class="info">
                        <span class="label">Gift Card ID:</span>
                        <span class="gift-card-id" qa="gift-card-id">{{
                            purchasedGiftCard?.giftCardID | giftCardID
                        }}</span>
                    </div>
                </div>
            </div>

            <button
                mat-stroked-button
                color="primary"
                (click)="print()"
                class="ols-mat-stroked-button-color"
            >
                Print Gift Card
            </button>
            <button
                mat-stroked-button
                color="primary"
                (click)="purchaseAnotherGiftCard()"
                class="ols-mat-stroked-button-color"
                qa="purchase-another-gc-button"
            >
                Purchase Another Gift Card
            </button>
        </mat-card>
    </div>
</div>

<div [id]="containerId" #printGiftCardContainer></div>
